import * as React from 'react';
import LocalDiv from '../../localization/LocalDiv';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';
import { useSelector } from 'react-redux';
import { AppState } from '../../core/redux/appState';
import { Map } from '../../language/models';
import { Message } from '../../localization/models';


type Props = {
  className?: string;
  isMobile: boolean;
}


const styles = {
  container:  css`
    font-size: 12px;
    margin: auto 0 18px !important;
    line-height: 1.4;
    text-align: center;
  `,
  icon:       css`font-size: 30px;`,
  csHeader:   css`
    display: block;
    font-weight: bold;
  `,
  phoneLinks: css`display: block;`,
};


const LoginFooter: React.FC<Props> = props => {
  const msgs = useSelector<AppState, Map<Message> | undefined>(
    state => state.locale.translations[`${state.locale.lang.languageId}`],
  ) || {};

  const customerSupport        = msgs[Str.CustomerSupport];
  const customerServicePhone   = msgs[Str.CustomerServicePhone];
  const footerPhoneLinks       = msgs[Str.FooterPhoneLinks];
  const footerSupportSiteLink  = msgs[Str.FooterSupportSiteLink];
  const footerCopyrightPrivacy = msgs[Str.FooterCopyrightPrivacy];

  const hasContactInfo = !!customerSupport && (
    (!!customerServicePhone && !!footerPhoneLinks) || !!footerSupportSiteLink
  );

  const hasCopyrightPrivacy = !!footerCopyrightPrivacy;

  if (!hasContactInfo && !hasCopyrightPrivacy) {
    return null;
  }

  return (
    <LocalDiv css={styles.container}>
      {
        hasContactInfo && (<><FontAwesomeIcon icon={faUserCircle} css={styles.icon} /><br /><br /></>)
      }
      <Msg css={styles.csHeader} defaultMsg='' str={Str.CustomerSupport} />
      <Msg
        css={styles.phoneLinks}
        defaultMsg=''
        str={props.isMobile ? Str.FooterPhoneLinks : Str.CustomerServicePhone}
      />
      <Msg defaultMsg='' str={Str.FooterSupportSiteLink} />
      {hasCopyrightPrivacy && <><br /></>}
      <Msg defaultMsg='' str={Str.FooterCopyrightPrivacy} />
    </LocalDiv>
  );
};


export default LoginFooter;